(function () {
    'use strict';

    angular
        .module('oddRoutes', [])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {

        $stateProvider

            // ODD Home
            .state('odd', {
                url: '/{CampaignTypeCode:odd|surveyv2}/{BusinessUnitCode:string}',
                resolve: {
                    progressBlocks: ['oddService', '$stateParams', 'errorManagementService', function (oddService, $stateParams, errorManagementService) {
                        return oddService.getBusinessUnitWithProgress($stateParams.BusinessUnitCode)
                            .then(function (progressBlocks) {
                                return progressBlocks;
                            }, function(response) {
                                errorManagementService.manageError(response)
                            })
                    }],
                    businessUnit: ['progressBlocks', function (progressBlocks) {
                        return progressBlocks.ODDBusinessUnit;
                    }]
                },
                templateUrl: require('./businessUnits.tpl.html'),
                controller: 'ODDBusinessUnitController'
            });
    }
})();